module.exports = __webpack_public_path__ + "./images/0060037ae69789f3fd8da7dc55acd4f1.webp";